/**
 * Condition names, colours and markers.
 *
 * These match `app/evaluwhale/exports/plots.py` exactly, so what a scientist
 * curates on screen looks like the figure that gets exported.
 */

export const CO = "co-incubation";
export const MINUS = "pre-incubation -NADPH";
export const PLUS = "pre-incubation +NADPH";

export const CONDITION_ORDER = [CO, MINUS, PLUS];

export const CONDITION_STYLE = {
  [CO]: { color: "#1f4e79", symbol: "circle" },
  [MINUS]: { color: "#c00000", symbol: "square" },
  [PLUS]: { color: "#2e7d32", symbol: "triangle-up" },
};

export const CONDITION_ANNOTATION = {
  [CO]: "IC50",
  [MINUS]: "IC50 (-NADPH)",
  [PLUS]: "IC50 (+NADPH)",
};

/** Short form for tabs and column headers, where the full name is too long. */
export const CONDITION_SHORT = {
  [CO]: "Co-incubation",
  [MINUS]: "Pre-inc. -NADPH",
  [PLUS]: "Pre-inc. +NADPH",
};

export function styleFor(condition) {
  return CONDITION_STYLE[condition] || { color: "#555555", symbol: "circle" };
}
